import React from 'react';
import { EnquiryProvider } from './contexts/EnquiryContext';
import { UtilityBar } from './components/layout/UtilityBar';
import { Header } from './components/layout/Header';
import { MobileActionBar } from './components/layout/MobileActionBar';
import { Footer } from './components/layout/Footer';
import { StructuredData } from './components/StructuredData';
import { Hero } from './components/sections/Hero';
import { ProofBar } from './components/sections/ProofBar';
import { InShort } from './components/sections/InShort';
import { Industries } from './components/sections/Industries';
import { Solutions } from './components/sections/Solutions';
import { Flagship } from './components/sections/Flagship';
import { DemoTour } from './components/sections/DemoTour';
import { Process } from './components/sections/Process';
import { Technology } from './components/sections/Technology';
import { Resources } from './components/sections/Resources';
import { FAQ } from './components/sections/FAQ';
import { Contact } from './components/sections/Contact';
export function App() {
  return <EnquiryProvider data-id="element-0" data-mp="3mlj82snzz920">
      <div className="min-h-screen w-full bg-white font-inter" data-id="element-1" data-mp="3ml17jjuay8oa">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-btn focus:bg-afb-ink focus:px-4 focus:py-2 focus:text-white" data-id="element-2" data-mp="3mj6k9yvk64h1">
          Skip to content
        </a>
        <StructuredData data-id="element-3" data-mp="2zmepodo7rua5" />
        <UtilityBar data-id="element-4" data-mp="2zmwh8wzxlkbq" />
        <Header data-id="element-5" data-mp="33mouhn09senf" />
        <main id="main" data-id="element-6" data-mp="33mf6g4yschkd">
          <Hero data-id="element-7" data-mp="33nq5jrhad155" />
          <ProofBar data-id="element-8" data-mp="33n6xr3lcnt4u" />
          <InShort data-id="element-9" data-mp="33orla998ybt7" />
          <Industries data-id="element-10" data-mp="38m1g64fenfof" />
          <Solutions data-id="element-11" data-mp="38li7lebna3n2" />
          <Flagship data-id="element-12" data-mp="38l00tnrcw70w" />
          <DemoTour data-id="element-13" data-mp="38nunzn1r85y0" />
          <Process data-id="element-14" data-mp="3dkuwe4m2tksa" />
          <Technology data-id="element-15" data-mp="3dle3sre3oqs2" />
          <Resources data-id="element-16" data-mp="3dlnu6g324zya" />
          <FAQ data-id="element-17" data-mp="3dm5ze27p6oic" />
          <Contact data-id="element-18" data-mp="3dii530ufhy2k" />
        </main>
        <Footer data-id="element-19" data-mp="nwc2huqftzxb" />
        <MobileActionBar data-id="element-20" data-mp="nuhjilyq8hvv" />
      </div>
    </EnquiryProvider>;
}